/**
 * The level an activity log entry is filed under.
 *
 * Callers have always expressed it as `details.level` — 97 call sites across the
 * booth already write `level: 'error'` next to the failure they just caught. The
 * store used to hardcode `'info'` and drop that, so every one of those failures
 * arrived in the dashboard looking like routine chatter, and an operator reading a
 * session's activity had no way to tell a crash from a button click. That is how
 * "recording bought, nothing delivered" stayed invisible (sessions uqd410, hz6byb).
 *
 * `'warning'` is read as `'warn'`: the print, upload and bingkai-kenangan paths
 * write it that way, and passing it through as-is would file every one of them
 * (the B33 "Session print skipped" with 0 copies among them) as `info`.
 *
 * `debug` is deliberately not accepted: ActivityLogs on the server enumerates
 * info/warn/error only, so anything else would be rejected on write.
 *
 * Lives in its own module — with no imports — so it can be tested without pulling
 * the renderer's whole module graph in behind `sessionState.ts`.
 */
export function resolveLogLevel(details?: Record<string, unknown>): 'info' | 'warn' | 'error' {
  const level = details?.level
  if (level === 'warning') return 'warn'
  return level === 'error' || level === 'warn' ? level : 'info'
}
